export const getInfoItems = (usage) => {
    const BASE_INFO_ITEMS = [
        '物业类别', '产权年限', '环线位置', '开发商', '楼盘地址', '占地面积',
        '建筑面积', '容积率', '绿化率', '绿地率', '停车位', '楼栋总数', '总户数',
        '物业公司', '物业费', '楼层状况', '交房时间', '售楼部地址'
    ]
    const BASE_BUSINESS_INFO_ITEMS = [
        '项目名称', '预售证号', '开发商', '物业公司', '物业类型', '装修情况', '产权年限',
        '规划户数', '楼层状况', '水电气', '物业费用', '层高', '开盘时间', '交房时间',
        '占地面积', '建筑面积', '容积率', '绿化率', '绿地率', '停车位', '售楼部'
    ]
    return usage === '商业' ? BASE_BUSINESS_INFO_ITEMS : BASE_INFO_ITEMS
}
function variableIcon (item, list) {
    return [
        {
            name: '楼盘评论',
            type: 'comment',
            class: 'building-comment',
            show: true
        },
        {
            name: '航拍看房',
            type: 'web720',
            class: 'web720',
            show: item.vr_panorama_resource && Boolean(item.vr_panorama_resource.vr_panorama_url)
        },
        {
            name: '楼盘总平',
            type: 'planar',
            class: 'planar',
            show: Boolean(item.planar_graph_url)
        },
        {
            name: 'VR看房',
            type: 'vr',
            class: 'vr',
            show: list.indexOf('vr') > -1
        },
        {
            name: '楼盘日照',
            type: 'sunlight',
            class: 'sunlight',
            show: list.indexOf('sunlight') > -1
        },
        {
            name: '语音讲解',
            type: 'audios',
            class: 'audios',
            show: item.audios.length > 0
        },
        {
            name: '置业顾问',
            type: 'consultant',
            class: 'consultant',
            show: true
        },
        {
            name: '房贷计算',
            type: 'mortgage',
            class: 'mortgage',
            url: '/packageA/loan_computer/main',
            show: true
        },
        {
            name: '购房流程',
            type: 'guide',
            class: 'guide',
            url: '/packageA/material/main',
            show: true
        },
        {
            name: '资格查询',
            type: 'qualification',
            class: 'qualification',
            url: '/check_condition/main',
            show: true
        }
    ]
}
export const initIconsData = (item, show_length=5) => {
    const icons_list = variableIcon(item, item.activities)
    let result = icons_list.filter((element) => element.show)
    return result.slice(0,show_length)
}

export const getNavigationInfo = () => {
    const { top, height } = wx.getMenuButtonBoundingClientRect()
    return {
        menu_top: top + 'px',
        menu_height: height + 'px',
        navigation_height: (top + height + 8 ) + 'px'
    }
}

export const getFavouriteText = (favourite, status) => {
    let text = ''
    switch (status) {
        case '即将取证':
            text = favourite ? '取消提醒' : '开盘提醒'
            break
        case '即将登记':
        case '正在登记':
        case '即将摇号':
            text = favourite ? '取消提醒' : '摇号提醒'
            break
        default:
            text = favourite ? '取消订阅' : '订阅楼盘'
            break
    }

    return text
}